<template>
  <div>
    <!-- Sans plan : la lancer (l'action attendue le dit déjà). Avec un plan arrêté : la reprendre. -->
    <div class="d-flex">
      <v-spacer />
      <v-btn small color="primary" :loading="working" @click="retry">
        <v-icon left small>mdi-play</v-icon>{{ $t(order.plan ? 'onboarding.commissioning.retry.resume' : 'onboarding.commissioning.retry.start') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import CommissioningRepository from '@repository/CommissioningRepository'

/**
 * La mise en service d'une commande sans pose (véhicule, badges) part par un job : s'il n'est jamais parti, ou s'est
 * arrêté sur une étape qu'on a fait corriger, on le relance d'ici. Le serveur ne le double jamais ; le plan reprend où
 * il s'était arrêté. Rend la commande à jour (`updated`).
 */
export default {
  name: 'OrderCommissioningRetry',

  props: {
    order: { type: Object, required: true },
  },

  data() {
    return { working: false }
  },

  methods: {
    async retry() {
      this.working = true
      try {
        const result = await CommissioningRepository.retryCommissioning(this.order.id)
        this.notifySuccess(`onboarding.commissioning.retry.outcome.${result.retry || 'launched'}`)
        this.$emit('updated', result)
      } catch (e) {
        this.notifyError(e)
      } finally {
        this.working = false
      }
    },
  },
}
</script>
